<template>
  <div>
    <div v-if="!uploadType" class="grid grid-cols-1 gap-12 lg:grid-cols-3">
      <RevCard class="order-2 p-32 lg:order-1 lg:col-span-2">
        <UploadForm :categories @submit="handleFormSubmit" />
      </RevCard>

      <Help class="order-1 h-fit lg:order-2" />
    </div>

    <div v-if="uploadType">
      <RevCard class="p-32">
        <Summary :selected-category :upload-type @back="handleBack" />
      </RevCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { RevCard } from '@ds/components/Card'

import type {
  TransformedCategory,
  UploadTypes,
} from './BatchListingCreation.types'
import { transform } from './BatchListingCreation.utils'
import Help from './components/Help/Help.vue'
import Summary from './components/Summary/Summary.vue'
import UploadForm from './components/UploadForm/UploadForm.vue'

const { data: categories } = useHttpFetch(
  merchantsAPI.getDocwebsiteCategories,
  {
    default: () => [],
    transform,
  },
)

const uploadType = ref<UploadTypes | null>(null)
const selectedCategory = ref<TransformedCategory | null>(null)

function reset() {
  uploadType.value = null
  selectedCategory.value = null
}

function handleBack() {
  reset()
}

function handleFormSubmit(payload: {
  uploadType: UploadTypes
  selectedCategoryId: string
}) {
  uploadType.value = payload.uploadType
  selectedCategory.value =
    categories.value.find(
      (category) =>
        category?.categoryId?.toString() === payload.selectedCategoryId,
    ) || null
}
</script>
